/**
 * Insert a new node after a reference node
 * @param newNode
 * @param referenceNode
 */ var insertNodeAfterReference = function(newNode, referenceNode) {
    if (referenceNode === null || referenceNode === void 0 ? void 0 : referenceNode.nextSibling) {
        var _referenceNode_parentNode;
        referenceNode === null || referenceNode === void 0 ? void 0 : (_referenceNode_parentNode = referenceNode.parentNode) === null || _referenceNode_parentNode === void 0 ? void 0 : _referenceNode_parentNode.insertBefore(newNode, referenceNode.nextSibling);
    } else {
        var _referenceNode_parentNode1;
        referenceNode === null || referenceNode === void 0 ? void 0 : (_referenceNode_parentNode1 = referenceNode.parentNode) === null || _referenceNode_parentNode1 === void 0 ? void 0 : _referenceNode_parentNode1.appendChild(newNode);
    }
};
var getBoundingRect = function(element) {
    return element.getBoundingClientRect();
};
export { insertNodeAfterReference, getBoundingRect };
